import React from 'react';
import { 
  Option1_FeaturedGrid, 
  Option2_Carousel, 
  Option3_BentoGrid, 
  Option4_SplitScreen, 
  Option5_Masonry 
} from '../components/PortraitOptions';

const PortraitGalleryOptions = () => {
  return (
    <div className="bg-black min-h-screen">
      {/* Introduction */}
      <div className="bg-[#0a0a0a] py-20 px-6 text-center border-b-4 border-[#FF6B6B]">
        <h1 className="font-display text-6xl md:text-8xl font-black text-white mb-6">
          PORTRAIT GALLERY <span className="text-[#FF6B6B]\">OPTIONS</span>
        </h1>
        <p className="text-gray-400 text-xl max-w-3xl mx-auto mb-8">
          Scroll through all 5 options to see different ways to showcase your professional portraits. 
          Each style offers a unique visual experience.
        </p>
        <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-500">
          <span className="px-4 py-2 bg-gray-900 rounded-full">Option 1: Featured + Grid</span>
          <span className="px-4 py-2 bg-gray-900 rounded-full">Option 2: Cinematic Carousel</span>
          <span className="px-4 py-2 bg-gray-900 rounded-full">Option 3: Bento Grid</span>
          <span className="px-4 py-2 bg-gray-900 rounded-full">Option 4: Split-Screen</span>
          <span className="px-4 py-2 bg-gray-900 rounded-full">Option 5: Masonry</span>
        </div>
      </div>

      {/* All Options */}
      <Option1_FeaturedGrid />
      <div className="h-px bg-gradient-to-r from-transparent via-[#FF6B6B] to-transparent"></div>
      
      <Option2_Carousel />
      <div className="h-px bg-gradient-to-r from-transparent via-[#4ECDC4] to-transparent"></div>
      
      <Option3_BentoGrid />
      <div className="h-px bg-gradient-to-r from-transparent via-[#FFD700] to-transparent"></div>
      
      <Option4_SplitScreen />
      <div className="h-px bg-gradient-to-r from-transparent via-[#FF6B6B] to-transparent"></div>
      
      <Option5_Masonry />
      
      {/* Footer */}
      <div className="bg-[#0a0a0a] py-12 px-6 text-center border-t-4 border-[#4ECDC4]">
        <p className="text-gray-400 text-lg">
          Choose your favorite style and let me know!
        </p>
      </div>
    </div>
  );
};

export default PortraitGalleryOptions;
